import axios from "axios";

// MAIN API BASE URL
let baseUrl;
if (window.location.origin === "http://localhost:3000") {
  baseUrl = "http://127.0.0.1:8000/";
} else {
  baseUrl = "https://stationapi.theicthub.com/";
}

const api = axios.create({
  baseURL: baseUrl,
});

// LOGGER System
const LOG_API_URL = "https://system-logger.onrender.com/log-request";

api.interceptors.request.use((config) => {
  config.metadata = { startTime: new Date() }; 
  return config;
});

api.interceptors.response.use(
  (response) => {
    const endTime = new Date();
    const duration = (endTime - response.config.metadata.startTime) / 1000;

    setTimeout(() => {
      axios.post(LOG_API_URL, {
        url: response.config.baseURL + response.config.url,
        method: response.config.method.toUpperCase(),
        request_payload: JSON.stringify(response.config.data || {}),
        response_data: JSON.stringify(response.data || {}),
        status_code: response.status,
        response_time: duration,
      }).catch(function (err) {
        console.error("Failed to log to FastAPI:", err);
      });
    }, 0);

    return response;
  },
  (error) => {
    const endTime = new Date();
    var startTime = new Date();

    if (error.config && error.config.metadata && error.config.metadata.startTime) {
      startTime = error.config.metadata.startTime;
    }

    var duration = (endTime - startTime) / 1000;
    var statusCode = 500;
    var responseData = "{}";
    var requestPayload = "{}";
    var requestUrl = "unknown";
    var method = "UNKNOWN";

    if (error.response && error.response.status) {
      statusCode = error.response.status;
    }

    if (error.response && error.response.data) {
      responseData = JSON.stringify(error.response.data);
    }

    if (error.config && error.config.data) {
      requestPayload = JSON.stringify(error.config.data);
    }

    if (error.config && error.config.baseURL && error.config.url) {
      requestUrl = error.config.baseURL + error.config.url;
    }

    if (error.config && error.config.method) {
      method = error.config.method.toUpperCase();
    }

    setTimeout(() => {
      axios.post(LOG_API_URL, {
        url: requestUrl,
        method: method,
        request_payload: requestPayload,
        response_data: responseData,
        status_code: statusCode,
        response_time: duration,
      }).catch(function (err) {
        console.error("Failed to log error to FastAPI:", err);
      });
    }, 0);

    return Promise.reject(error);
  }
);



export default api;

